var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_25_1",
    "data-name": "Componente 25 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.793,
    height: 75.497,
    viewBox: "0 0 79.793 75.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "oko",
    d: "M208.042,238.067a4.509,4.509,0,1,1-4.509,4.509A4.509,4.509,0,0,1,208.042,238.067Z",
    transform: "translate(-192.679 -226.393)",
    fill: "#487473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "oko_1",
    d: "M302.762,238.067a4.509,4.509,0,1,1-4.509,4.509A4.509,4.509,0,0,1,302.762,238.067Z",
    transform: "translate(-237.352 -226.393)",
    fill: "#487473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "R_copy",
    "data-name": "R copy",
    d: "M282,219.48l1.306,1.659.81,1.028s14.345-7.921,24.3,1.218l1.062.52s-2.453-13.25-23.925-5.5C284.422,218.713,283.24,219.067,282,219.48Z",
    transform: "translate(-229.687 -215.973)",
    fill: "#487473"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "L_copy",
    "data-name": "L copy",
    d: "M210.471,219.5l-1.306,1.655-.81,1.026s-14.345-7.9-24.3,1.215l-1.062.519s2.453-13.222,23.925-5.488C208.049,218.738,209.231,219.092,210.471,219.5Z",
    transform: "translate(-182.991 -215.988)",
    fill: "#487473"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "new_vector_shape_done",
    d: "M262.069,274.333h.789c1.631,2.215,2.295,5.62,3.156,8.567a6.521,6.521,0,0,1-.225,3.156c-.855,2.365-3.539,2.322-5.749,3.382a6.2,6.2,0,0,1-1.8.9c-.5-.441-1.106-.528-1.353-1.24-.609-.838.176-1.362.789-1.691,1.113-.6,4.548-1.185,4.96-2.254.509-.579.171-2.32,0-2.931a34.321,34.321,0,0,0-1.24-4.283c-.394-.938-1.086-1.926-.676-3.043A5.919,5.919,0,0,0,262.069,274.333Z",
    transform: "translate(-217.737 -243.498)",
    fill: "#487473",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "usta",
    d: "M274.719,325.823c-5.184,4.5-16.893,8.784-30.517,8.784s-25.333-4.283-30.517-8.784c0,0-.53-1.459.248-2.238a2.637,2.637,0,0,1,2.034-.62c5.179,4.5,14.606,8.219,28.235,8.219s23.057-3.715,28.235-8.219c0,0,1.267-.471,1.882.145A2.408,2.408,0,0,1,274.719,325.823Z",
    transform: "translate(-201.318 -268.807)",
    fill: "#487473"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_-",
    "data-name": "-",
    d: "M245.347,350.707H263.6v2.852H245.347Z",
    transform: "translate(-211.873 -278.062)",
    fill: "#487473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy-face.bb1e26232bf9ca13e2eaad03981cda7f.svg";
export { ForwardRef as ReactComponent };